import { FileDetailsDTO, DocumentDTO, BlobFileDetails } from '../../api/plyca-dtos';
import {
  Component,
  AfterContentInit,
  OnInit,
  Input,
  ViewChild,
  ViewContainerRef,
  HostListener,
  ElementRef,
  QueryList,
  ViewChildren,
  OnDestroy
} from '@angular/core';
import { DocumentService } from '../document.service';
import { ServiceLocator } from './../../ServiceLocator';
import { Configuration } from '../../../app/conf/app.constants';
import { TokenService } from '../../token.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { AppConfiguration } from '../../conf/app.configuration';

declare var jQuery: any;

@Component({
  selector: 'filePDFViewer',
  templateUrl: 'filePDFViewer.template.html'
})
export class filePDFViewerComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input()
  showZoom: boolean;
  @Input()
  showPages: boolean;
  @Input()
  showToolbar: boolean;
  @Input()
  showRotation: boolean;
  @Input()
  showExpandButton = true;
  @Input()
  showAllPagesDocument: boolean;
  @Input()
  currentFile: FileDetailsDTO;

  @ViewChild('viewer')
  pdfViewer: ViewContainerRef;


  @ViewChild('element') element: ElementRef;
  @ViewChildren('elementChild') elementChild: QueryList<any>;


  private props: BehaviorSubject<any>;
  public propsObservable: Observable<any>;

  document: DocumentDTO;
  // documentService: DocumentService;
  // appComponent: AppComponent;

  numberPages = 0;
  pdfSrc: any;
  page = 1;
  rotation = 0;
  zoom = 1;
  originalSize = false;
  expanded = false;
  renderTextConfig = false;

  pdf: PDFDocumentProxy;
  // progressData: PDFProgressData;
  zoomFactor = 1;


  private documentService: DocumentService;
  public tokenService: TokenService;

  private _configuration: Configuration;
  private focusTrap: FocusTrapFactory;

  constructor(
    private appConfig: AppConfiguration,
    private elem: ElementRef
  ) {
    this.props = new BehaviorSubject<any>({
      showExpanded: false,
      showFloatInfo: false
    });
    this.propsObservable = this.props.asObservable();
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.tokenService = ServiceLocator.injector.get(TokenService);
    this._configuration = ServiceLocator.injector.get(Configuration);
    this.focusTrap = ServiceLocator.injector.get(FocusTrapFactory);
    (<any>window).pdfWorkerSrc = 'assets/js/pdf.worker.js';

  }

  ngOnInit(): void {

    this.renderTextConfig = this.appConfig.getValue('pdfviewer.renderText');
    this.loadDocument();
  }

  ngAfterContentInit(): void {
    if (this.pdfViewer) {

      console.log(
        'ancho viewer->',
        this.pdfViewer.element.nativeElement.offsetLeft,
        this.pdfViewer.element.nativeElement.offsetParent.clientWidth
      );
      this.zoom = this.pdfViewer.element.nativeElement.offsetParent.clientWidth / 1000;

    }

    if (this.element) {
      this.element.nativeElement.focus();
    }
    /*
        this.focusTrap.create(
          this.elem.nativeElement).focusLastTabbableElementWhenReady()
          .then(focussed => {
            console.log('**** Foco en -> ');
            console.log(document.activeElement);
            document.getElementById('focus').focus();
          }
          );*/
  }

  ngOnDestroy() {
    this.props.complete();
    this.pdf = null;
    this.pdfViewer = null;
    jQuery('body').removeClass('dialog-full');
  }

  incrementZoom(amount: number) {
    this.zoom += amount;


  }

  rotate(angle: number) {
    this.rotation += angle;
  }

  incrementPage(amount: number) {
    this.page += amount;
  }

  @HostListener('window:resize', ['$event'])
  onPageResize() {
    this.zoom = this.pdfViewer.element.nativeElement.offsetParent.clientWidth / 1000;
  }

  @HostListener('document:keydown.escape', ['$event'])
  public closeExpandOnEscape() {
    if (this.expanded) {
      this.toogleExpand();
    }
  }

  loadDocumentItem(fileItem: FileDetailsDTO): void {
    if (fileItem && fileItem.links) {
      this.currentFile = fileItem;
      console.log('this.currentFile', this.currentFile);
      // let url = this.currentFile.download.links[0].href + '?embedded=true';
      let url =
        this._configuration.ServerWithUserApiUrl + 'documentFiles/' +
        this.currentFile.identifier +
        '?embedded=true';
      console.log(url);

      let authHeaderName = this.tokenService.getAuthHaderName();

      this.pdfSrc = {
        url: url,
        httpHeaders: {
          [authHeaderName]: 'Bearer ' + this.tokenService.getAccessToken()
        }
      };
    }
  }

  loadDocument(): void {
    if (this.currentFile && (this.currentFile instanceof BlobFileDetails)) {
      let blob = (<BlobFileDetails>this.currentFile).fileContent;
      blob.arrayBuffer().then(buffer => this.pdfSrc = buffer);
    } else if (this.currentFile && this.currentFile.links) {
      this.currentFile = this.currentFile;
      console.log('this.currentFile', this.currentFile);
      let url = this.currentFile.download.links[0].href + '?embedded=true';
      console.log(url);

      let authHeaderName = this.tokenService.getAuthHaderName();;

      this.pdfSrc = {
        url: url,
        httpHeaders: {
          [authHeaderName]: 'Bearer ' + this.tokenService.getAccessToken()
        }
      };


    }

  }

  toogleExpand() {
    let newProps: any = this.props.value;
    newProps.showExpanded = !newProps.showExpanded;
    this.expanded = newProps.showExpanded;
    this.props.next(newProps);
    this.focusTrap
      .create(this.elem.nativeElement).focusLastTabbableElementWhenReady()
      .then(focussed => {
        console.log('**** Foco en -> ' + document.activeElement)
      });
    // Establecemos la clase para que el dialogo ocupe la pantalla completa
    if (this.expanded) {
      jQuery('body').addClass('dialog-full');
    }
    else {
      jQuery('body').removeClass('dialog-full');
    }
  }

  toogleShowInfo() {
    let newProps: any = this.props.value;
    newProps.showFloatInfo = !newProps.showFloatInfo;
    this.props.next(newProps);
  }

  downloadFile(fileItem: FileDetailsDTO) {
    // console.log("Método downloadFile");

    this.documentService.downloadEmbedded(fileItem);
  }

  printFile(fileItem: FileDetailsDTO) {
    // console.log("Método downloadFile");

    this.documentService.printFile(fileItem);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pdf = pdf;
  }

  /*onProgress(progressData: any) {
    console.log(progressData);
    this.progressData = progressData;
  }

  pageRendered(e: CustomEvent) {
    console.log('(page-rendered)', e);
  }*/

  public initPage(): boolean {
    if (this.page == 1) {
      return true;
    }
    return false;
  }

  public lastPage(): boolean {
    if (this.page == this.pdf.numPages) {
      return true;
    }
    return false;
  }

  public isLoaded(): boolean {
    return this.document != null && this.pdf != null; // && this.progressData && this.progressData.loaded >= this.progressData.total;
  }

  public isShowToolbar(): boolean {
    return this.showToolbar;
  }

  public isShowPages(): boolean {
    return this.showPages && this.pdf != null;
  }

  public isShowZoom(): boolean {
    return this.showZoom;
  }

  public isShowRotation(): boolean {
    return this.showRotation;
  }

  public isShowAllPagesDocument(): boolean {
    return this.showAllPagesDocument;
  }

  isExpanded() {
    return this.expanded;
  }

  renderText() {
    return this.renderTextConfig;
  }
}
